import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/storageAnalysis';

export async function getStorageSummary(token, month, year) {
  try {
    const response = await axios.get(`${API_BASE_URL}/summary`, {
      headers: { Authorization: "Bearer " + token },
      params: { month, year }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getStorageDeviceBreakdown(token, month, year) {
  try {
    const response = await axios.get(`${API_BASE_URL}/devices`, {
      headers: { Authorization: "Bearer " + token },
      params: { month, year }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getStorageProcessBreakdown(token, month, year) {
  try {
    const response = await axios.get(`${API_BASE_URL}/processes`, {
      headers: { Authorization: "Bearer " + token },
      params: { month, year }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function sendStorageReportByEmail(email, token, month, year) {
  try {
    const response = await axios.post(`${API_BASE_URL}/report/email`, { email, month, year }, {
      headers: { Authorization: "Bearer " + token }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}
